import { CenterFlex, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import type { ButtonOptionT } from '@/components/Button/Button/types';
import Typo from '@/components/Typography/Typo';
import { cn } from '@/lib/cn';

import Heading from '../Typography/Heading';

export type EmptyProps = {
  image?: React.ReactNode;
  icon?: React.ReactNode;
  title: string;
  description?: string | React.ReactNode;
  action?: {
    onClick: () => void;
    text: string;
    option?: ButtonOptionT;
    icon?: React.ReactNode;
  };
  className?: string;
};

const Empty = (props: EmptyProps) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center w-full h-150 gap-5',
        props.className,
      )}
    >
      {props.image && props.image}
      {props.icon && (
        <CenterFlex className="size-10 text-2xl text-gray-700">
          {props.icon}
        </CenterFlex>
      )}
      <VFlex a="center" g={10}>
        <Heading type="h5" weight="sb" className="text-gray-700">
          {props.title}
        </Heading>
        {props.description && (
          <Typo type="body2" weight="r" className="text-gray-600">
            {props.description}
          </Typo>
        )}
      </VFlex>
      {props.action && (
        <Button
          sizeType="m"
          onClick={props.action.onClick}
          variant={props.action.option || 'primary'}
          leftIcon={props.action.icon}
        >
          {props.action.text}
        </Button>
      )}
    </div>
  );
};

export default Empty;
